export default "__VITE_ASSET__B7aoE2hZ__"